import { ReqModel } from "src/app/shared/models/bases/base-req.model";

class Body {
  customerNo: string;
  channelTypeCode: string;
  loginUserID: string;
}

export class PME0512Req extends ReqModel {
  constructor() {
    super();
  }
  public body = new Body();
}
